module.exports = __webpack_public_path__ + "img/img_no_data.0a99f7ef.png";